import React from 'react';
import { getHistogramYAxisValues } from '../../utils';
var HistogramYAxis = function (_a) {
    var maxPercent = _a.maxPercent;
    var labels = getHistogramYAxisValues(maxPercent);
    return (React.createElement("div", { className: "histogramYAxis" }, labels.reverse().map(function (label) { return React.createElement("div", { key: label, className: "histogramYAxis__label" },
        label,
        "%"); })));
};
export default HistogramYAxis;
//# sourceMappingURL=HistogramYAxis.js.map